import tooltipConfig from "@/misc/chartTooltip";
let _this;
export default {
  props: {
    labels: {
      type: Array,
    },
    chartData: {
      type: Array,
      required: true,
    },
    toolTipIndex: {
      type: Number,
    },
    chartAttr: {
      type: Object,
    },
  },
  watch: {
    toolTipIndex(newVal) {
      const chart = this.$data._chart;
      let activeElements = [];
      if (!newVal && newVal !== 0) {
        chart.tooltip._active = activeElements;
        chart.tooltip.update(true);
        chart.draw();
        return;
      }
      let requestedElem = chart.getDatasetMeta(0).data[newVal];
      for (let i = 0; i < activeElements.length; i++) {
        if (requestedElem._index === activeElements[i]._index) {
          return;
        }
      }
      activeElements.push(requestedElem);
      chart.tooltip._active = activeElements;
      chart.tooltip.update(true);
      chart.draw();
    },
  },
  computed: {
    dataSetObject() {
      const MAIN_COLOR = "#16C6B9";
      let base = {
        data: this.chartData,
        backgroundColor: "rgba(22, 198, 185, 0.2)", // todo: set valiable
        hoverBackgroundColor: MAIN_COLOR,
        borderColor: MAIN_COLOR,
      };
      if (this.chartId === "line-chart") {
        const gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 100);
        gradient.addColorStop(0, "rgba(22, 198, 185, 0.5)");
        gradient.addColorStop(0.9, "rgba(22, 198, 185, 0)");
        base = {
          ...base,
          backgroundColor: gradient,
          pointHoverBackgroundColor: MAIN_COLOR,
          borderWidth: 2,
          pointHoverRadius: 3,
        };
      }
      return [base];
    },
  },
  mounted() {
    _this = this;
    this.renderChart(
      {
        labels: this.labels,
        datasets: this.dataSetObject,
      },
      {
        layout: {
          padding: {
            right: 10,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        elements: { point: { radius: 0.01, hoverRadius: 4, hitRadius: 3 } },
        scales: {
          xAxes: [
            {
              ticks: {
                display: false,
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                display: false,
                beginAtZero: true,
              },
              gridLines: {
                display: false,
                drawBorder: false,
              },
            },
          ],
        },
        onHover: function (event, element) {
          if (!element || element.length === 0) {
            _this.$emit("tooltipIndexChanged", null);
            return;
          }
          _this.$emit("tooltipIndexChanged", element[0]._index);
        },
        tooltips: {
          ...tooltipConfig,
          displayColors: false,
          intersect: false,
          callbacks: {
            title(tooltipItem, _data) {
              return _this.$options.filters.DateString(tooltipItem[0].xLabel);
            },
            label: function (tooltipItem, data) {
              let format = "0,0";
              if (data.datasets[0].data[tooltipItem.index] < 1) {
                format = "0.0%";
              }
              return _this.$options.filters.numberFormat(data.datasets[0].data[tooltipItem.index], format);
            },
            labelTextColor: function (_tooltipItem, _data) {
              return "#3A3A3A";
            },
          },
        },
      }
    );
  },
};
